import { gql } from 'apollo-angular';

export const RemoveFunnelFromFavouriteDocument = gql`
  mutation removeFunnelFromFavourites($funnelId: Int!) {
    removeFunnelFromFavourites(funnelId: $funnelId)
  }
`;
